import type { ReactNode } from 'react';
import { Spinner } from './Spinner';

type Kind = 'connecting' | 'reconnecting' | 'ended' | 'error';

interface StatusOverlayProps {
  kind: Kind;
  title: string;
  caption?: string;
  action?: ReactNode;
}

const tone: Record<Kind, { bg: string }> = {
  connecting:   { bg: 'bg-black/60' },
  reconnecting: { bg: 'bg-black/60' },
  ended:        { bg: 'bg-black/80' },
  error:        { bg: 'bg-black/80' },
};

export function StatusOverlay({ kind, title, caption, action }: StatusOverlayProps) {
  const showSpinner = kind === 'connecting' || kind === 'reconnecting';
  return (
    <div className={`absolute inset-0 grid place-items-center ${tone[kind].bg} animate-[fadeIn_var(--duration-fast)_var(--ease-out)_both]`}>
      <div className="space-y-3 text-center">
        {showSpinner && <Spinner className="mx-auto h-6 w-6 text-text-secondary" />}
        <h1 className={kind === 'connecting' || kind === 'reconnecting'
          ? 'font-mono text-xs uppercase tracking-[0.2em] text-text-secondary'
          : 'font-[var(--font-serif)] text-2xl font-bold italic text-text-primary'
        }>
          {title}
        </h1>
        {caption && (
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-text-muted">{caption}</p>
        )}
        {action}
      </div>
    </div>
  );
}
